import React from "react";
import clsx from "clsx";
import { useTranslate } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Chip, Typography, Icon, CardActions } from "@material-ui/core";
import { GetWfStatus } from "utils/options";
//import {  IconButton, Collapse, CardContent } from "@material-ui/core";
//import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paperStatusOther: {
    padding: theme.spacing(1, 2),
    margin: "auto",
    maxWidth: 500,
    cursor: "pointer",
  },
  paperStatusNormal: {
    borderLeft: "4px solid #2196f3",
    padding: theme.spacing(1, 2),
    margin: "auto",
    maxWidth: 500,
    cursor: "pointer",
  },
  paperStatusVoid: {
    borderLeft: "4px solid #e57373",
    padding: theme.spacing(1, 2),
    margin: "auto",
    maxWidth: 500,
    cursor: "pointer",
  },
  statusOther: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
  },
  statusNormal: {
    backgroundColor: "#2196f3",
    color: "white",
  },
  statusVoid: {
    backgroundColor: "#e57373",
    color: "white",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
}));

const MbCard = (props) => {
  const translate = useTranslate();
  const classes = useStyles();
  const { data, NumberFormat, DateToString, wfSteps, wfEnumStatus } = props;
  //const [expanded, setExpanded] = React.useState(false);
  // const handleExpandClick = () => {
  //   setExpanded(!expanded);
  // };

  if (!data) {
    return (
      <div className={classes.root}>
        <Paper align="center">
          <br />
          <Icon fontSize="large">report</Icon>
          <br />
          <Typography gutterBottom variant="subtitle1">
            Sorry, no matching records found
          </Typography>
          <br />
        </Paper>
      </div>
    );
  }
  return (
    <div className={classes.root}>
      <Paper
        className={clsx(classes.paperStatusOther, {
          [classes.paperStatusNormal]: data?.PyhStatus === "Effective" || data?.PyhStatus === "Printed",
          [classes.paperStatusVoid]: data?.PyhStatus === "Void",
        })}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={1}>
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1">
                  {translate("ra.field.Payment No.")} : {data.PyhSeq}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {DateToString(data.PyhDate)}
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="subtitle1" align="right">
                {translate("ra.field.Total")} : <b>{NumberFormat(data.PyhAmt)}</b>
              </Typography>
            </Grid>
          </Grid>
          <div style={{ marginTop: -8, padding: "0 8px 8px 8px" }}>
            <Typography variant="body2" gutterBottom>
              {data.VnCode} : {data.VnName}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {data.PyhDesc}
            </Typography>
          </div>
          <CardActions disableSpacing style={{ marginTop: -10, width: "100%", justifyContent: "space-between" }}>
            <div>
              <Chip
                label={GetWfStatus(wfSteps, wfEnumStatus, data.PyhStatus)}
                size="small"
                className={clsx(classes.statusOther, {
                  [classes.statusNormal]: data.PyhStatus === "Effective",
                  [classes.statusVoid]: data.PyhStatus === "Void",
                })}
              />
            </div>
            {/* <div>
              <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded,
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </IconButton>
            </div> */}
          </CardActions>
          {/* <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>

            </CardContent>
          </Collapse> */}
        </Grid>
      </Paper>
    </div>
  );
};

export default MbCard;
